import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../Types/type.js';
// Компоненты пользовательского интерфейса
import FormContainer from '../CustomElements/FormContainer.jsx';
import Input from '../CustomElements/Input.jsx';
import CustomButton from '../CustomElements/CustomButton.jsx';
import CustomContainer from '../CustomElements/CustomContainer.jsx';
import CustomTitle from '../CustomElements/CustomTitle.jsx';
import ConfirmationPage from '../CustomElements/ConfirmationPage.jsx';
import CustomTextarea from '../CustomElements/CustomTextarea.jsx';

// Кастомные хуки
import { useButtonValidation } from '../../customHook/useButtonValidation.js';
import useOptionalFieldsForAddRC from '../../customHook/useOptionalFieldsForAddRC';

// Утилиты
import { handleUniversalChange } from '../../utils/formUtils.js';
import { coordinateFormat, isCoordinateAllowed } from '../../utils/coordinateFormat.js';
import { useInfocard } from './Common.jsx';
import { parseCoordinatesString } from '../../utils/railChainsTableInputChangeHandlers';
import { removeEmptyStrings } from '../../utils/removeEmptyStrings.js';
import { convertStringValuesToNumbers } from '../../utils/convertStringValuesToNumbers.js';

// Действия Redux
import { addRailChainsFromServer } from '../../redux/actions/infocards.action.js';
import { load, remove } from '../../redux/actions/loader.action.js';

// компонент для добавления РЦ
function AddRailChains({ closeModal, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  // Получаем данные о процессе
  const loader = useSelector((state) => state.loader);

  // получаем id дороги и станции
  const { stationId, road } = useInfocard();

  // состояние для сообщения об ошибке
  const [messageError, setMessageError] = useState(false);

  // состояние для отображения успешного добавления
  const [addSuccess, setAddSuccess] = useState(false);

  // Закрывает модальное окно после успешного добавления нового устройства
  const handlerCloseModal = () => {
    closeModal();
    setAddSuccess(false);
  };

  // Состояние для формы
  /**
   * @type {FormDataAddRailCains}
   */
  const [formData, setFormData] = useState({
    id: '',
    road: road,
    stationId: stationId,
    object: '',
    railChainName: '',
    //Длина участка оповещения
    alertLengthsPCh: '',
    alertLengthsECh: '',
    // Координаты концов РЦ
    coordinateEndLat: '',
    coordinateEndLon: '',
    ordEnd: '',
    //Координаты контролируемое ответвление
    coordinateControlledLatA: '',
    coordinateControlledLonA: '',
    controlledOrdA: '',
    coordinateControlledLatB: '',
    coordinateControlledLonB: '',
    controlledOrdB: '',
    coordinateControlledLatV: '',
    coordinateControlledLonV: '',
    controlledOrdV: '',
    coordinateControlledLatG: '',
    coordinateControlledLonG: '',
    controlledOrdG: '',
    //Координаты неконтролируемое ответвление
    coordinateUncontrolledLatN1: '',
    coordinateUncontrolledLonN1: '',
    uncontrolledOrdN1: '',
    coordinateUncontrolledLatN2: '',
    coordinateUncontrolledLonN2: '',
    uncontrolledOrdN2: '',
    coordinateUncontrolledLatN3: '',
    coordinateUncontrolledLonN3: '',
    uncontrolledOrdN3: '',
    //Координаты трек
    track: '',
  });

  // состояние для необязательных полей
  const optionalFields = useOptionalFieldsForAddRC(formData);

  // Функция для проверки валидности формы
  const isButtonDisabled = useButtonValidation(formData, optionalFields);

  const onApply = () => {
    // проверяем строку трек, если есть невалидные значения записываем в стейт наличие ошибки
    const { invalidCoordinatesIds, coordinatesArray } = parseCoordinatesString(formData?.track, formData?.id);
    if (invalidCoordinatesIds?.length) {
      setMessageError(true);
      return;
    }    
    // режим загрузки
    dispatch(load());
    // Удаляем пустые строки из formData
    const formWithoutEmptyStrings = removeEmptyStrings(formData);
    // Определяем поля, которые нужно преобразовать в числа
    const skipFields = new Set(['object', 'railChainName']);
    const fieldsToConvert = Object.keys(formWithoutEmptyStrings).filter((key) => !skipFields.has(key));
    // Преобразуем нужные строковые значения в числа
    const transformedPayload = convertStringValuesToNumbers(formWithoutEmptyStrings, fieldsToConvert);
    dispatch(addRailChainsFromServer(stationId, {...transformedPayload, track: coordinatesArray}));
  };

  //отслеживаем выполнение запроса
  useEffect(() => {
    // Если нет ошибок, закрываем модальное окно
    if (!loader?.isLoading && loader?.isSuccess) {
      setAddSuccess(true);
    }
    // при закрытии компонента чистим стейт загрузки
    return () => {
      dispatch(remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loader?.isLoading, loader?.isSuccess]);

  // отслеживаем поле трек при изменении  стираем сообщение об ошибке
  useEffect(() => {
    setMessageError('');
  }, [formData?.track]);

  // проверка если поле обязательное ставим звездочку
  const getLabel = (fieldName, label) => {
    const isRequired = !optionalFields.includes(fieldName);
    return isRequired ? `${label} *` : label;
  };

  return (
    <CustomContainer>
      <CustomTitle titleText={t?.addRailChainTitle || 'ДОБАВЛЕНИЕ НОВОЙ РЕЛЬСОВОЙ ЦЕПИ'} />
      {addSuccess && (
        <ConfirmationPage
          confirmText={t?.railChainAdded || 'Рельсовая цепь успешно добавлена'}
          onConfirm={handlerCloseModal}
          addNew={t?.goToRailChains || 'К списку РЦ'}
        />
      )}
      {!addSuccess && (
        <>
          <FormContainer id={467535} columns={3}>
            <Input
              column="left"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="id"
              label={t?.railChainId || 'ID рельсовой цепи *'}
              placeholder={t?.inputRailChainId || 'Введите ID РЦ'}
              width="100%"
              height="var(--sadr-font-size-60)"
              format="######"
              maxLength={9}
              isCoordinate={true}
              isAllowed={undefined}
            />
            <Input
              column="center"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="railChainName"
              label={t?.railChainName || 'Рельсовая цепь *'}
              placeholder={t?.inputRailChainName || 'Введите название РЦ'}
              width="100%"
              height="var(--sadr-font-size-60)"
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="object"
              label={t?.objectName || 'Объект *'}
              placeholder={t?.inputObjectName || 'Введите название объекта'}
              width="100%"
              height="var(--sadr-font-size-60)"
            />
          </FormContainer>
          <h4 className="add-rail-chain-title mb-3">{t?.alertLengthTitle || 'Длина участка оповещения'}</h4>
          <FormContainer id={46758935}>
            <Input
              column="left"
              onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 4)}
              name="alertLengthsPCh"
              label={t?.labelPCh || 'ПЧ'}
              placeholder={t?.inputPCh || 'Введите ПЧ'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="9999"
            />
            <Input
              column="center"
              onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 4)}
              name="alertLengthsECh"
              label={t?.labelECh || 'ЭЧ'}
              placeholder={t?.inputECh || 'Введите ЭЧ'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="9999"
            />
          </FormContainer>
          <h4 className="add-rail-chain-title mb-3">{t?.feedEnd || 'Питающий конец'}</h4>
          <FormContainer id={46997535} columns={3}>
            <Input
              column="left"
              label={getLabel('coordinateEndLat', t?.endLatLabel || 'Питающий конец (широта)')}
              placeholder={t?.inputLatitude || 'Введите широту'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateEndLat"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="center"
              label={getLabel('coordinateEndLon', t?.endLonLabel || 'Питающий конец (долгота)')}
              placeholder={t?.inputLongitude || 'Введите долготу'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateEndLon"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="ordEnd"
              label={t?.endOrdLabel || 'Питающий конец (ордината)'}
              placeholder={t?.endOrdPlaceholder || 'Введите ординату питающего конца'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="99999999"
            />
          </FormContainer>
          <h4 className="add-rail-chain-title mb-3">{t?.controlledBranch || 'Контролируемое ответвление'}</h4>
          <FormContainer id={46535} columns={3}>
            {/* "А" релейный конец */}
            <Input
              column="left"
              label={getLabel('coordinateControlledLatA', t?.relayALatLabel || '«А» релейный конец (широта)')}
              placeholder={t?.inputLatitude || 'Введите широту'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateControlledLatA"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="center"
              label={getLabel('coordinateControlledLonA', t?.relayALonLabel || '«А» релейный конец (долгота)')}
              placeholder={t?.inputLongitude || 'Введите долготу'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateControlledLonA"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="controlledOrdA"
              label={t?.relayAOrdLabel || '«А» релейный конец  (ордината)'}
              placeholder={t?.inputOrd || 'Введите ординату'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="99999999"
            />
            {/* "Б"  */}
            <Input
              column="left"
              label={getLabel('coordinateControlledLatB', t?.bLatLabel || '«Б»  (широта)')}
              placeholder={t?.inputLatitude || 'Введите широту'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateControlledLatB"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="center"
              label={getLabel('coordinateControlledLonB', t?.bLonLabel || '«Б»  (долгота)')}
              placeholder={t?.inputLongitude || 'Введите долготу'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateControlledLonB"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="controlledOrdB"
              label={t?.bOrdLabel || '«Б» (ордината)'}
              placeholder={t?.inputOrd || 'Введите ординату'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="99999999"
            />
            {/* "В"  */}
            <Input
              column="left"
              label={getLabel('coordinateControlledLatV', t?.vLatLabel || '«В»  (широта)')}
              placeholder={t?.inputLatitude || 'Введите широту'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateControlledLatV"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="center"
              label={getLabel('coordinateControlledLonV', t?.vLonLabel || '«В»  (долгота)')}
              placeholder={t?.inputLongitude || 'Введите долготу'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateControlledLonV"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="controlledOrdV"
              label={t?.vOrdLabel || '«В» (ордината)'}
              placeholder={t?.inputOrd || 'Введите ординату'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="99999999"
            />
            {/* "Г"  */}
            <Input
              column="left"
              label={getLabel('coordinateControlledLatG', t?.gLatLabel || '«Г»  (широта)')}
              placeholder={t?.inputLatitude || 'Введите широту'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateControlledLatG"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="center"
              label={getLabel('coordinateControlledLonG', t?.gLonLabel || '«Г»  (долгота)')}
              placeholder={t?.inputLongitude || 'Введите долготу'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateControlledLonG"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="controlledOrdG"
              label={t?.gOrdLabel || '«Г» (ордината)'}
              placeholder={t?.inputOrd || 'Введите ординату'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="99999999"
            />
          </FormContainer>
          <h4 className="add-rail-chain-title mb-3">{t?.uncontrolledBranch || 'Неконтролируемое ответвление'}</h4>
          <FormContainer id={46757735} columns={3}>
            {/* "H1"  */}
            <Input
              column="left"
              label={getLabel('coordinateUncontrolledLatN1', t?.h1LatLabel || '«H1»  (широта)')}
              placeholder={t?.inputLatitude || 'Введите широту'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateUncontrolledLatN1"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="center"
              label={getLabel('coordinateUncontrolledLonN1', t?.h1LonLabel || '«H1»  (долгота)')}
              placeholder={t?.inputLongitude || 'Введите долготу'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateUncontrolledLonN1"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="uncontrolledOrdN1"
              label={t?.h1OrdLabel || '«H1» (ордината)'}
              placeholder={t?.inputOrd || 'Введите ординату'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="99999999"
            />
            {/* "H2"  */}
            <Input
              column="left"
              label={getLabel('coordinateUncontrolledLatN2', t?.h2LatLabel || '«H2»  (широта)')}
              placeholder={t?.inputLatitude || 'Введите широту'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateUncontrolledLatN2"
              width={'100%'}
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="center"
              label={getLabel('coordinateUncontrolledLonN2', t?.h2LonLabel || '«H2»  (долгота)')}
              placeholder={t?.inputLongitude || 'Введите долготу'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateUncontrolledLonN2"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="uncontrolledOrdN2"
              label={t?.h2OrdLabel || '«H2» (ордината)'}
              placeholder={t?.inputOrd || 'Введите ординату'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="99999999"
            />
            {/* "H3"  */}
            <Input
              column="left"
              label={getLabel('coordinateUncontrolledLatN3', t?.h3LatLabel || '«H3»  (широта)')}
              placeholder={t?.inputLatitude || 'Введите широту'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateUncontrolledLatN3"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="center"
              label={getLabel('coordinateUncontrolledLonN3', t?.h3LonLabel || '«H3»  (долгота)')}
              placeholder={t?.inputLongitude || 'Введите долготу'}
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="coordinateUncontrolledLonN3"
              width="100%"
              height="var(--sadr-font-size-60)"
              isCoordinate={true} // Устанавливаем, что это координатный ввод
              format={coordinateFormat} // Передаем кастомный формат
              isAllowed={isCoordinateAllowed} // Передаем кастомную валидацию
              messageInfo={t?.messageInfo || 'Формат: DD.DDDDDD'}
            />
            <Input
              column="right"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="uncontrolledOrdN3"
              label={t?.h3OrdLabel || '«H3» (ордината)'}
              placeholder={t?.inputOrd || 'Введите ординату'}
              width="100%"
              height="var(--sadr-font-size-60)"
              mask="99999999"
            />
            {/* ТРЕК */}
            <h4 className="add-rail-chain-title mb-3" columnspan={3}>
              {t?.track || 'Трек'}
            </h4>
            <CustomTextarea
              label={t?.trackLabel || '«Трек»  (координаты) '}
              placeholder={
                t?.trackPlaceholder || 'Введите координаты в формате: широта, долгота; широта, долгота;  . . . ;'
              }
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="track"
              width="100%"
              height="var(--sadr-font-size-200)"
              message={messageError ? t?.trackError || 'Координаты в поле трек введены некорректно' : ''}
              restrictTextInput
              columnspan={3}
            />
            <CustomButton
              key="add_rc"
              width="var(--sadr-font-size-420)"
              height="var(--sadr-font-size-60)"
              text={t?.addRailChain || 'Добавить РЦ'}
              onClick={onApply}
              disabled={isButtonDisabled}
              isButton
            />
          </FormContainer>
        </>
      )}
    </CustomContainer>
  );
}

export default AddRailChains;
